<div class="card">
  <!-- Card Header -->
  <div class="px-4 py-3 border-b">
    <h3 class="text-lg font-semibold">State Fees</h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <kendo-grid
      [kendoGridBinding]="repState.stateListWithInactive"
      [pageSize]="20"
      [pageable]="true"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <button type="button" icon="plus-outline" look="flat" (click)="buttonclicked()" kendoGridAddCommand
          class="mr-2 bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition">
          Add New Record
        </button>
        <button type="button" icon="refresh-sm" look="flat" kendoButton
          class="bg-gray-200 dark:bg-gray-700 px-3 py-1 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition">
          Refresh
        </button>
      </ng-template>

      <kendo-grid-column *ngIf="!hiderow" field="stateValue" title="State Abb." width="75" [editable]="false"
        class="disabled-column"></kendo-grid-column>

      <kendo-grid-column field="stateValue" title="State Abb." width="75" *ngIf="hiderow">
        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup">
          <input class="k-textbox k-adjust-width" [formControl]="formGroup.get(column.field)" maxlength="2" kendoTextBox />
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="stateText" title="State Name" width="150">
        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup">
          <input class="k-textbox k-adjust-width" [formControl]="formGroup.get(column.field)" maxlength="50" kendoTextBox />
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="bdfees" title="BD Fee" width="75">
        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup">
          <kendo-numerictextbox [format]="'n2'" [spinners]="false" class="k-adjust-width" [formControl]="formGroup.get(column.field)">
          </kendo-numerictextbox>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="iafees" title="IA Fee" width="75">
        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup">
          <kendo-numerictextbox [format]="'n2'" [spinners]="false" class="k-adjust-width" [formControl]="formGroup.get(column.field)">
          </kendo-numerictextbox>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="active" title="Active" width="75">
        <ng-template kendoGridCellTemplate let-column>
          <input type="checkbox" [checked]="column.active" disabled />
        </ng-template>
        <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-column="column">
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title="Command" width="175">
        <ng-template kendoGridCellTemplate>
          <button kendoGridEditCommand [primary]="true" (click)="showfield()"
            class="mr-1 bg-yellow-500 text-white px-2 py-1 rounded">Edit</button>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid"
            class="mr-1 bg-green-600 text-white px-2 py-1 rounded">Save</button>
          <button kendoGridCancelCommand class="bg-gray-400 text-white px-2 py-1 rounded">Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
